var map = {
	"./instrument-bonuses.png": "26da",
	"./instrument-market.png": "9139",
	"./instrument-offers.png": "1d85",
	"./instrument-promotion.png": "bb3c",
	"./instrument-rating.png": "5c4c",
	"./instrument-reducing-costs.png": "98c3",
	"./instrument-statistics.png": "f792",
	"./instrument-traffic.png": "d7cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9dfe";